// Preset avatar icons shipped in public/avatars (avatar-01.svg .. avatar-50.svg).
// Count must match server/constants/avatars.js so random-default assignment
// on signup lines up with what the picker offers.
export const PRESET_AVATAR_COUNT = 50;

export const PRESET_AVATARS = Array.from(
  { length: PRESET_AVATAR_COUNT },
  (_, i) => `/avatars/avatar-${String(i + 1).padStart(2, '0')}.svg`
);

export function isPresetAvatar(value) {
  return typeof value === 'string' && /^\/avatars\/avatar-\d{2}\.svg$/.test(value);
}
